import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import theme from "../theme";

const FellowCard = ({ name, year, image }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 100,
        cursor:'pointer'
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 130,
          height: 130,
          borderRadius: "50%",
          overflow: "hidden",
          "&:hover .overlay": {
            opacity: 1,
          },
        }}
      >
        <Avatar
          alt={name}
          src={image}
          sx={{ width: "100%", height: "100%" }}
        />

        {/* Hover Overlay */}
        <Box
          className="overlay"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              textAlign: "center",
              px: 1,
            }}
          >
            {name}
          </Typography>
        </Box>
      </Box>

      {/* Year shown below the avatar */}
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.primary.main,
          fontWeight: 600,
          textAlign: "center",
          mt: 1,
        }}
      >
        {year}
      </Typography>
    </Box>
  );
};

export default FellowCard;
